<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Número</th>
          <th>Data de emissão</th>
          <th>Paciente</th>
          <th>Convênio</th>
          <th>Solicitante</th>
          <th>Nº de Agendamentos</th>
          <th>Especialidade</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="guia in guias" :key="guia._id">
          <td>{{ guia.autorizacao.numeroGuia }}</td>
          <td>{{
            formatarData(guia.autorizacao.dataEmissao, 'DD/MM/YYYY')
          }}</td>
          <td>{{ guia.beneficiario.nome }}</td>
          <td>{{ guia.beneficiario.plano }}</td>
          <td>{{ guia.contratadoSolicitante.profissionalSolicitante.nome }}</td>
          <td>{{ guia.agendamentos.length }}</td>
          <td>{{ guia.especialidade }}</td>
          <td v-if="guia.bloqueada">Enviada para Faturamento</td>
          <td v-else>Aberta</td>
          <td>
            <RouterLink
              v-tooltip="'Editar'"
              data-test-id="link-auto-1"
              :to="'/guia/cadastro/' + guia._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
            <button
              id="botaoExportarPdf"
              v-tooltip="'Imprimir'"
              data-test-id="button-botaoexportarpdf"
              name="botaoExportarPdf"
              type="button"
              class="btn btn-xs btn-link"
              @click.prevent="exportarGuia(guia)"
            >
              <span class="fa fa-file-o" />
            </button>
            <RouterLink
              v-tooltip="'Ver agendamentos'"
              data-test-id="link-auto-3"
              :to="'/guia/' + guia._id + '/agendamentos'"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-calendar" />
            </RouterLink>
            <button
              id="botaoLimpar"
              v-tooltip="'Remover'"
              data-test-id="button-botaolimpar"
              name="botaoLimpar"
              type="button"
              class="btn btn-xs btn-link"
              @click="deletar(guia)"
            >
              <span class="fa fa-trash" />
            </button>
            <button
              v-if="!guia.bloqueada && verificaAcao('faturamento_guia')"
              id="botarEnviarFaturamento"
              v-tooltip="'Enviar Para Faturamento'"
              data-test-id="button-botarenviarfaturamento"
              name="botarEnviarFaturamento"
              type="button"
              class="btn btn-xs btn-link"
              @click="enviarParaFaturamento(guia)"
            >
              <span class="fa fa-lock" />
            </button>
            <button
              v-if="
                guia.enviarParaFaturamento && verificaAcao('faturamento_guia')
              "
              id="botaoRemoverFaturamento"
              v-tooltip="'Remover do Faturamento'"
              data-test-id="button-botaoremoverfaturamento"
              name="botaoRemoverFaturamento"
              type="button"
              class="btn btn-xs btn-link"
              @click="removerDoFaturamento(guia)"
            >
              <span class="fa fa-unlock" />
            </button>
            <button
              id="botaoBloquearPagamento"
              v-tooltip="'Bloquear Pagamento'"
              data-test-id="button-botaobloquearpagamento"
              name="botaoBloquearPagamento"
              type="button"
              class="btn btn-xs btn-link"
              @click="bloquearPagamento(guia)"
            >
              <span class="fa fa-exclamation-triangle" />
            </button>
            <button
              id="botaoDesbloquearPagamento"
              v-tooltip="'Desbloquear Pagamento'"
              data-test-id="button-botaodesbloquearpagamento"
              name="botaoDesbloquearPagamento"
              type="button"
              class="btn btn-xs btn-link"
              @click="desbloquearPagamento(guia)"
            >
              <span class="fa fa-check-square" />
            </button>
            <button
              id="botaoGuiaConsulta"
              v-tooltip="'Gerar Guia Consulta'"
              data-test-id="button-botaoguiaconsulta"
              name="botaoGuiaConsulta"
              type="button"
              class="btn btn-xs btn-link"
              @click="gerarGuiaConsulta(guia)"
            >
              <span class="fa fa-file-o" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import * as formatadores from '@/utils/formatadores'
const controleAcessoServico = new ControleAcessoServico()

export default {
  name: 'GuiaTabela',
  props: {
    guias: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
    deletar(guia) {
      this.$emit('guiaDeletada', guia._id)
    },
    enviarParaFaturamento(guia) {
      this.$emit('guiaEnviadaParaFaturamento', guia._id)
    },
    removerDoFaturamento(guia) {
      this.$emit('guiaRemovidaDoFaturamento', guia._id)
    },
    bloquearPagamento(guia) {
      this.$emit('guiaPagamentoBloqueado', guia._id)
    },
    desbloquearPagamento(guia) {
      this.$emit('guiaPagamentoDesbloqueado', guia._id)
    },
    exportarGuia(guia) {
      this.$emit('exportarGuia', guia._id)
    },
    gerarGuiaConsulta(guia) {
      this.$emit('gerarGuiaConsulta', guia._id)
    },
  },
}
</script>
